import {call, put, takeLatest} from 'redux-saga/effects'
import Logger from '../../../helpers/logger'
import {AxiosServices} from '../../../network/AxiosService';
import {ApiServices} from '../../../network/ApiServices';
import {SERVICES} from "../../constants/services";

function* fetchServicesPageData(actions) {
  try {
    const result = yield call(
      AxiosServices.get,
      ApiServices.GET_PAGE_BY_TYPE_DATA,
      actions.params
    )

    yield put({
      type: SERVICES.FETCH_SERVICES_PAGE.SUCCESS,
      result:  result.data
    })
  } catch(err) {
    Logger(err)
    yield put({
      type: SERVICES.FETCH_SERVICES_PAGE.FAILURE
    })
  }
}


export default function* serviceSaga() {
  yield takeLatest(SERVICES.FETCH_SERVICES_PAGE.MAIN, fetchServicesPageData);
}
